import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

import './styles/tokens.css';
import './styles/app.css';

const saved = localStorage.getItem('faforge-theme');
if (saved === 'light' || saved === 'dark') {
  document.documentElement.setAttribute('data-theme', saved);
}

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
